module.exports = __webpack_public_path__ + "static/img/doublelift.ea60b65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/doublelift.jpg
// module id = V/gn
// module chunks = 35